export default "__VITE_ASSET__CiW_1$T6__"